import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

export class AppUtility {
  //To check if a value is numeric
  static isNumeric(val = null) {
    if (val !== undefined && val !== null && val !== "" && !isNaN(parseInt(val))) {
      return true;
    } else {
      return false;
    }
  }

  //To check start and end range is already overlapping with existing list of ranges
  static isNotValidRange(startRange = 0, endRange = 0, existingRangeList = []) {
    let _result = true;
    try {
      let _sRange = this.isNumeric(startRange) ? parseFloat(startRange) : 0;
      let _eRange = this.isNumeric(endRange) ? parseFloat(endRange) : 0;
      if ((_sRange === 0) & (_eRange === 0)) {
        _result = true;
      } else {
        if (existingRangeList.length === 0) {
          _result = false;
        } else {
          _result = existingRangeList.some((exRange, index) => {
            return parseFloat(exRange.startRange) <= _eRange && parseFloat(exRange.endRange) >= _sRange;
          });
        }
      }
    } catch (e) {
    } finally {
      return _result;
    }
  }

  //To download data grid list in excel
  static handleDownload = (recordList, fileName) => {
    try {
      const worksheet = XLSX.utils.json_to_sheet(recordList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(workbook, {
        booktype: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: "xlsx" });
      FileSaver.saveAs(data, fileName);
    } catch (e) {
      alert(e);
    }
  };

  // Function to validate email format
  static validateEmail = (email) => {
    let validator = require("email-validator");
    return validator.validate(email);
  };

  // Function to validate start date is less than end date
  static validateDates = (startDate, endDate) => {
    return new Date(startDate) <= new Date(endDate);
  };

  // Function to group by array
  static groupBy(array, key) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  }

  //convert camel case to readable string
  static toTitleCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, str[0].toUpperCase());
  };
}
